import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, inject, Input } from '@angular/core';
import { TextInputComponent } from '../../../../../../ui/form-components/text-input/text-input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MaskitoOptions } from '@maskito/core';
import { MaskitoDirective } from '@maskito/angular';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-review-text-input',
  standalone: true,
  imports: [MaskitoDirective, NgIf],
  templateUrl: './review-text-input.component.html',
  styleUrls: ['./review-text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ReviewTextInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewTextInputComponent extends TextInputComponent {
  @Input() maskOptions: MaskitoOptions | null = null;

  private cdr = inject(ChangeDetectorRef);

  public setDisabledState(isDisabled: boolean): void {
    super.setDisabledState?.(isDisabled);
    this.cdr.markForCheck();
  }

  public writeValue(value: string | null): void {
    super.writeValue(value);
    this.cdr.markForCheck();
  }
}
